import request from '../../shared/request'

export function getCompanyAddresses(payload) {
  return request(`/address/${payload.companyId}`)
}

export function companyCreateAddress(payload) {
  return request(`/address/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function companyUpdateAddress(payload) {
  return request(`/address/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function companyDeleteAddress(payload) {
  return request(`/address/${payload.address_id}/`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateCompanyPrimaryAddress(payload) {
  return request(`/address/${payload.address_id}/primary`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/address.js